import { mq, variables } from '../../../../cssInJs';

export default{
    attributes__wrap : {
        cursor: 'pointer',
        height: '100%',
        paddingLeft: '0.3rem',
        paddingRight: '0.3rem',
        '&:hover':{
            background: variables.bgColor
        }
    },
    attributes__title : mq({
        display:'flex',
        '.attr__arrow' : {
            marginRight: '0.5rem',
            lineHeight:0,
            height:'auto',
            marginTop: 'auto',
            marginBottom: 'auto'
        }
    }),
    attributeItem__container : mq({
        display: 'flex',
        fontWeight: 400,
        '.attributeItem__item__value' : mq({
            marginLeft: '0.2rem'
        })
    }),

    portal__background : {
        backgroundColor: 'rgba(0,0,0,0.3)',
        position: 'fixed',
        top:'0px',
        left: '0px',
        width: '100%',
        height: '100%',
        zIndex: '9998'
    },
    portal__popupcontainer : mq({
        position: 'fixed',
        top:'50%',
        left: '50%',
        width: '100%',
        zIndex: '9999',
        margin: '0px',
        transform: 'translate(-50%, -50%)',
        maxWidth: ['320px', null, '560px']
    }),
    select__attribute : {
        backgroundColor:'white',
        textAlign:'center',
        maxWidth: ['320px', null, '560px'],
        margin: 'auto',
        padding: '0.5rem 0',
        borderRadius: '10px'
    },
    selectattribute__title : {
        position:'relative',
        paddingTop: '0.5rem',
        paddingBottom: '0.6rem',
        fontSize: '1.3rem',
        fontWeight:500,
        '.selectattribute__close' : {
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform:'translateY(-50%)',
            cursor: 'pointer',
            borderRadius:'50%',
            lineHeight: '0px',
            padding : '5px',
            '&:hover' : {
                backgroundColor: '#ebebeb'
            }
        }
    },

    selectattribute__item : mq({
        textAlign:'left'
    }),
    selectattribute__item__name : {
        backgroundColor:'#f5f3f1',
        padding:'0.3rem 0.5rem',
        paddingLeft : '28px',
        fontWeight:500,
        fontSize:'1.2rem'
    },
    selectattribute__item__options : {
        padding:'0.3rem 0.5rem',
        fontWeight:700,
        cursor: 'pointer',
        '&.selected' : {
            color: '#017a39'
        },
        '.check' : {
            //display : 'none'
            width : '20px',
            display:'inline-block'
        }
    }
}